


const successModalTarget = document.querySelector('[data-modal-target="contactSuccess"]');

const submitType = localStorage.getItem('contact_type');
const successForm = document.querySelector('contact-success'); 
const successParam = getUrlParameter('contact_posted');  

const custSuccessParam =  getUrlParameter('customer_posted');  
const custSuccessParam2 = getUrlParameter('form_type'); 

const successData = document.querySelector('success-data');


const currentUrl = window.location.href; 
const searchString = 'challenge?form';

const isChallenge = currentUrl.includes(searchString);
console.log(searchString, 'SEARCH');
console.log(isChallenge, 'IS THIS A CHALLENGE?');

 

if(successData) {
const title = successData.querySelector('[data-title]').innerHTML; 
const content = successData.querySelector('[data-content]').innerHTML;   
successForm.querySelector('[data-success-title]').innerHTML = title;
successForm.querySelector('[data-success-content').innerHTML = content;
}

if (submitType == 'quote-form') {
  const successModalContent = document.querySelector(
    '[data-contact-success-content]'
  );
  const title = localStorage.getItem('quoteProduct');
  const imageSrc = localStorage.getItem('quoteImageSrc');
  const imageSrcset = localStorage.getItem('quoteImageSrcset'); 
  console.log('LOCAL STORAGE', title, imageSrc, imageSrcset);
if(imageSrc) {
  successModalContent.querySelector('[data-product-image] img').src = imageSrc;
  successModalContent.querySelector('[data-product-image] img').srcset =
    imageSrcset; 
  successModalContent.querySelector('[data-quote-display-title]').innerHTML =
    title;
} else {
    successModalContent.querySelector('[data-product-image]').classList.add('hide');
}
} 

if(successParam && !isChallenge) {
  console.log('Form Success'); 
  modalPop(successModalTarget);
}

console.log(custSuccessParam2, 'CUST SUCCESS 2');

if(custSuccessParam || custSuccessParam2 === 'customer' && !isChallenge) {
  console.log('Newsletter Form Success'); 
  const welcomePop = document.querySelector('[data-modal-target="welcomePop"]');
  const cookieDays = welcomePop ? parseInt(welcomePop.dataset.cookieDays) : 5;
  setCookie('welcomePop', 'seen', cookieDays); 
  modalPop(successModalTarget);
}